/**
 * Created by Ning Jiang on 2/27/2020.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {DeadwoodGameConfig} from "../../DeadwoodGameConfig";
import {DeadwoodBonusReelController} from "../../reel/DeadwoodBonusReelController";
import {DeadwoodReelView} from "../../reel/DeadwoodReelView";
import {DeadwoodParsedGameData} from "../../server/data/DeadwoodParsedGameData";
import {IDeadwoodParsedServerData} from "../../server/data/IDeadwoodParsedServerData";
import {DeadwoodBonusSymbol} from "../../symbols/DeadwoodBonusSymbol";
import {TweenLite} from "gsap";

export class StickyBonusController extends ReelStopPresentationController {

    private _nextMode:string;
    private _fsSuperModeActive:boolean;
    private _bonusTriggered:boolean;
    private _bonusPositions:number[];
    private _stickyBonusSymbols:(DeadwoodBonusSymbol | null)[] = [];

    private _stickyLayer:ScalableLayer;

    private get stickyLayer():ScalableLayer {
        if(!this._stickyLayer) {
            this._stickyLayer = StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.STICKY_BONUS.name);
        }
        return this._stickyLayer;
    }

    constructor(index:number) {
        super(index, "StickyBonus");
    }

    // no need to restore sticky B, the server gives them in init reels.
    protected parseFeatureGameData(data:DeadwoodParsedGameData):void {
        this.parseData(data);
    }

    private parseData(data:IDeadwoodParsedServerData):void {
        this._nextMode = data.nextMode;
        this._fsSuperModeActive = data.fsSuperModeActive;
        this._bonusTriggered = data.bonusTriggeredThisSpin;
        this._bonusPositions = data.bonusPositions;
    }

    protected addFeatureEventHandlers():void {
        // TODO: check if better use BEFORE_START event.
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.parseData(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.START, () => this.onSpinStart());
    }

    private onSpinStart():void {
        if(this._fsSuperModeActive && this._nextMode !== GameMode.NORMAL) {
            this.lockBonus(0, this._bonusPositions[0]);
            this.lockBonus(4, this._bonusPositions[4]);
        }
    }

    private lockBonus(reelId:number, symbolId:number):void {
        if(symbolId < 0) {
            debugger;
            throw new Error(`StickyBonusController.lockBonus() bonusPosition is missing at reel${reelId}`);
        }
        const reelSymbol:DeadwoodBonusSymbol = <DeadwoodBonusSymbol>Reels.getSymbol(reelId, symbolId);
        if(!reelSymbol) {
            debugger;
            Logger.logDev(`StickyBonusController.lockBonus() Cannot find bonus symbol at reel${reelId} symbol${symbolId}`);
            return;
        }
        const newSymbol:DeadwoodBonusSymbol = new DeadwoodBonusSymbol("B", reelId, DeadwoodGameConfig.instance.SYMBOL_STATES.broken, {
            width : GameConfig.instance.SYMBOL_WIDTH,
            height : GameConfig.instance.SYMBOL_HEIGHT,
            bottomPadding : GameConfig.instance.SYMBOL_BOTTOM_PADDING
        });
        const position:[number, number] = Helper.getSymbolPositions(reelId, symbolId, true);
        newSymbol.position.set(position[0], position[1]);
        this.stickyLayer.addChild(newSymbol);
        if(this._stickyBonusSymbols[reelId] != null) {
            debugger;
            Logger.logDev(`StickyBonusController.lockBonus() sticky symbol already exists at reel${reelId} symbol${symbolId}`);
        }
        this._stickyBonusSymbols[reelId] = newSymbol;
        reelSymbol.visible = false;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(this._fsSuperModeActive && !this._bonusTriggered && (data.reelId === 0 || data.reelId === 4)) {
            this.fadeOutReelSymbolBehindBonus(data.reelId, this._bonusPositions[data.reelId]);
        }
    }

    private fadeOutReelSymbolBehindBonus(reelId:number, symbolId:number):void {
        const reelSymbol:StateReelSymbol = Reels.getSymbol(reelId, symbolId)!;
        TweenLite.to(reelSymbol, 0.1, {alpha : 0});
    }


    public onReelSpinStopped(data:IReelStoppedData):void {
        if(this._fsSuperModeActive && !this._bonusTriggered && (data.reelId === 0 || data.reelId === 4)) {
            this.putBonusBackToReel(data.reelId, this._bonusPositions[data.reelId]);
        }
        this.dispatchCompleteEvent(data.reelId);
    }

    private putBonusBackToReel(reelId:number, symbolId:number):void {
        const reelSymbol:StateReelSymbol = Reels.getSymbol(reelId, symbolId)!;
        const stickySymbol:DeadwoodBonusSymbol = this._stickyBonusSymbols[reelId]!;
        if(!stickySymbol) {
            debugger;
            throw new Error(`StickyBonusController.putBonusBackToReel() cannot find sticky symbol at reel${reelId} symbol${symbolId}`);
        }
        stickySymbol.position.set(reelSymbol.x, reelSymbol.y);
        const reel:DeadwoodBonusReelController = <DeadwoodBonusReelController>Reels.getReel(reelId)!;
        (<DeadwoodReelView>reel.view).addSymbolToWinContainer(stickySymbol);
        reel.allSymbols[symbolId + GameConfig.instance.SYMBOLS_NUM_IN_REEL[0] + GameConfig.instance.SYMBOLS_NUM_IN_REEL[1]] = stickySymbol;
        reel.removeReplacedSymbol(reelSymbol);
        this._stickyBonusSymbols[reelId] = null;
    }
}